import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'unity-checkbox',
  templateUrl: './unity-checkbox.component.html',
  styleUrls: ['./unity-checkbox.component.scss']
})
export class UnityCheckboxComponent implements OnInit {
  @Input() classes: string;
  @Input() label: string;
  @Input() labelFor: string;
  @Input() checked: any;
  @Input() id: any = null;
  @Input()
  get inputModel() {
    return this.value;
  }
  set inputModel(val) {
    this.value = val;
    this.inputModelChange.emit(this.value);
  }

  @Output() inputModelChange = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  value = null;

  constructor() {}

  ngOnInit(): void {}
}
